// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q5QH2","textarea":"styles_textarea__3F8kf"};